import { useEffect } from 'react';
import { BoxSelect } from '@wkda/funnel-components';
import { Field } from 'react-final-form';
import { useCarleadCreationFormStore } from '../../Form/CarleadCreationFormStore';
import shallow from 'zustand/shallow';
import { jsx as _jsx } from "react/jsx-runtime";
function BoxFieldRenderer(_ref) {
  let {
    input,
    props
  } = _ref;
  const {
    type: _type,
    ...restInput
  } = input;
  const {
    onChange,
    mktSelector
  } = props;
  const [value, setLabel] = useCarleadCreationFormStore(state => [state.values[input.name], state.setLabel], shallow);
  useEffect(() => {
    if (typeof value !== 'undefined') {
      setLabel(input.name, props.options.find(o => o.value === value)?.label);
    }
    return () => {
      setLabel(input.name, undefined);
    };
  }, [input.name, props.options, setLabel, value]);
  return /*#__PURE__*/_jsx(BoxSelect, {
    ...restInput,
    ...props,
    onChange: v => {
      restInput.onChange(v);
      onChange(v);
    },
    mktSelector: mktSelector?.value
  });
}
export function boxSelectRenderer(_ref2) {
  let {
    name,
    ...props
  } = _ref2;
  return /*#__PURE__*/_jsx(Field, {
    name: name,
    props: props,
    render: BoxFieldRenderer
  });
}